module.exports = __webpack_public_path__ + "static/img/two.f7d02c2.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/infoService/14/two.png
// module id = S0zj
// module chunks = 1